import React from 'react';

/**
 * Una tabella lunga spezzata in due colonne affiancate.
 *
 * I pannelli hanno una riga per squadra, e le squadre di una edizione sono qualche decina: in una
 * colonna sola la tabella e' piu' alta dello schermo. Prima si risolveva con una striscia che
 * scorreva dentro il pannello, che e' la cosa peggiore - una barra di scorrimento dentro la
 * pagina, e meta' dei dati nascosti dietro un gesto che nessuno fa. Qui invece le righe si
 * dividono in due tabelle affiancate: si vede tutto insieme, e a scorrere e' la pagina.
 *
 * Sotto la soglia la tabella resta una sola: due colonne da tre righe sarebbero un vezzo. Quando
 * lo schermo e' stretto le due tabelle si impilano da sole, che e' l'unico caso in cui una
 * colonna sola ha senso.
 */

/** Da quante righe in su conviene spezzare. */
const SOGLIA = 12;

const TabellaDoppia = ({ intestazioni, righe, riga }) => {
  const meta = Math.ceil(righe.length / 2);
  const blocchi = righe.length >= SOGLIA ? [righe.slice(0, meta), righe.slice(meta)] : [righe];

  return (
    <div className="tabelle-affiancate">
      {blocchi.map((blocco, indice) => (
        <table className="tabella-compatta" key={indice}>
          <thead>
            <tr>
              {intestazioni.map(intestazione => (
                <th key={intestazione.testo} title={intestazione.titolo}>{intestazione.testo}</th>
              ))}
            </tr>
          </thead>
          <tbody>{blocco.map(riga)}</tbody>
        </table>
      ))}
    </div>
  );
};

export default TabellaDoppia;
